module.exports = __webpack_public_path__ + "static/media/lead-contact.e58593e4.png";